import "./TimeoutAssessmentModal.scss";
import Modal from "@mui/material/Modal";
import { Backdrop, FormControl, Grid } from "@mui/material";
import timeoutSVG from "assets/timer_timeout.svg";
import { useTranslation } from "react-i18next";
import { useAssignmentsContext } from "components/AssignmentsProvider";

const TimeoutAssessmentModal = (props) => {
  const { open, handleClose } = props;
  const { fireCandidateFeedbackSubmittedEvent } = useAssignmentsContext();
  const { t } = useTranslation();
  const goToRecruiterLandingPage = () => {
    // Fire the event to the recruiter
    fireCandidateFeedbackSubmittedEvent("timeout-explore-scalyz");

    window.location.href = `${process.env.REACT_APP_LANDING_URL}/recruiter` || "";
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      slots={{ backdrop: Backdrop }}
      sx={{ zIndex: 101 }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(100px)",
          },
        },
      }}
    >
      <div
        style={{
          outline: "none",
          display: "flex",
        }}
        className="timeout-assessment-modal"
      >
        <div className="timeout-assessment-form-timeout">
          <Grid container>
            <Grid item xs={12}>
              <p className="timeout-assessment-form-timeout-title">
                {t("time-is-up")}!
              </p>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ marginTop: "6px", marginBottom: "23px" }}
            >
              <p className="timeout-assessment-form-timeout-subtitle">
                {t("your-lab-session-has-ended")}
              </p>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={timeoutSVG}
                alt="timer"
                className="timeout-assessment-form-timeout-illustration"
              />
            </Grid>
            <div className="rounded-[20px] bg-white shadow-[0px_4px_12px_0px_rgba(13,_10,_44,_0.06)] w-full custom-text-[poppins-400-16px] px-[57px] py-[50px]">
              <p>The test duration has expired.<br /> Your answers have been saved automatically up to this point and will be sent to your recruiter.</p>
            </div>
            <Grid item xs={12} style={{ display: "flex" }}>
              <FormControl
                fullWidth
                style={{ display: "flex", alignItems: "center" }}
              ></FormControl>
            </Grid>
            <div className="flex justify-center w-full">
              <button
                onClick={goToRecruiterLandingPage}
                disabled={!process.env.REACT_APP_LANDING_URL}
                className="rounded-[20px] bg-blue px-6 py-3 text-white transition-colors custom-text-[poppins-600-14px] mt-[60px] shadow-[0px_7px_29px_0px_rgba(100,100,111,0.20)] hover:bg-blue-dark disabled:opacity-50 w-[171px] h-[53px]"
              >
                {t('explore-scalyz')}
              </button>
            </div>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default TimeoutAssessmentModal;